import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import type { LocationAllowedOsUpdate } from '@rocksoft/shared';

export type LocationAllowedOsUpdateState = EntityState<LocationAllowedOsUpdate>;

export function selectId(update: LocationAllowedOsUpdate) {
  return `${update.locationId}-${update.productKey}-${update.version}`;
}

export const adapter: EntityAdapter<LocationAllowedOsUpdate> = createEntityAdapter<LocationAllowedOsUpdate>({
  selectId,
});

export const initialState: LocationAllowedOsUpdateState = adapter.getInitialState();
